import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/public/i18n/LocaleProvider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/index.css");
